import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MapPoint from "components/maps/MapPoint";
import MapPointManager from "components/maps/MapPointManager";

const PrevWaypoints = ({ item, showPreview, _Tt }) => {
    return (
        <div className={`col preview-row ${showPreview ? "" : "d-none"}`}
            style={{ width: "300px", maxWidth: "300px" }}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{ width: "300px" }}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon={item.icon} />
                            </div>
                            <div className="preview-title">
                                <label>{_Tt("common.name")}</label>
                                <div>{item.name}</div>
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{_Tt("containers.latitude")}</label>
                            <div className="preview-input">{item.lat}</div>
                        </div>
                        <div className="preview-item">
                            <label>{_Tt("containers.longitude")}</label>
                            <div className="preview-input">{item.lng}</div>
                        </div>
                        <div className="preview-item mb-3">
                            <label>{_Tt("common.time")}</label>
                            <div className="preview-input">{item.time}</div>
                        </div>
                        {
                            item.lat && item.lng
                                ? <div className="preview-item mt-3">
                                    <MapPointManager center={[item.lat, item.lng]} />
                                </div>
                                : <></>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrevWaypoints

